import { Card, CardBody, CardHeader, Input } from "@heroui/react"
import { PaperAirplaneIcon } from "@heroicons/react/24/outline"
import { Button } from "@heroui/react"
import PropTypes from "prop-types"

const ContactDetails = ({ 
  email, 
  handleSave, 
  handleUpdate, 
  isDirty = false, 
  isLoading,
  isSaving = false, 
  phone 
}) => (
  <Card className="mt-3">
    <CardHeader className="justify-between text-white bg-indigo-700">
      <div className="flex items-center">
        <PaperAirplaneIcon className="mr-2 w-14 h-14" />

        <div className="flex flex-col mr-8">
          <h1 className="text-lg font-semibold">Contact Details</h1>
          <p className="text-sm">
            These details will appear on the parent portal.
          </p>
        </div>
      </div>

      <Button color="success" isDisabled={!isDirty || isLoading} isLoading={isSaving} className="font-semibold text-white" onPress={() => handleSave()}>Save</Button>
    </CardHeader>

    <CardBody>          
      <div className="px-4 pb-3 border-gray-200 border-dotted border-b-1">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="font-semibold">Phone</h3>
            <p className="text-content2-foreground">Contact phone</p>
          </div>

          <Input 
            className="max-w-96" 
            placeholder="Enter your enquiries phone number" 
            isDisabled={isLoading}
            value={phone} 
            onValueChange={(value) => handleUpdate('phone', value)} 
          />
        </div>
      </div>

      <div className="px-4 py-3">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="font-semibold">Email</h3>
            <p className="text-content2-foreground">Contact email</p>               
          </div>
          
          <Input 
            className="max-w-96" 
            placeholder="Enter your email for enquiries" 
            isDisabled={isLoading}
            value={email} 
            onValueChange={(value) => handleUpdate('email', value)} 
          />
        </div>
      </div>
    </CardBody>
  </Card>
)

ContactDetails.propTypes = {
  email: PropTypes.string,
  handleSave: PropTypes.func.isRequired,
  handleUpdate: PropTypes.func.isRequired,
  phone: PropTypes.string,
  isDirty: PropTypes.bool,
  isLoading: PropTypes.bool,
  isSaving: PropTypes.bool,
}

export default ContactDetails